import { chimeraQuery } from '@/helpers/graphql-chimera';

export default {
  state: {
    categories: [],
    courses: [],
    disciplines: {},
    subjects: {},
    topics: {},
    videosFromPepper: [],
  },
  getters: {},
  mutations: {
    SET_CATEGORIES(state: any, categories: any) {
      state.categories = categories;
    },

    SET_DESCOMPLICA_COURSES(state: any, courses: any) {
      state.courses = courses;
    },

    SET_DISCIPLINES(state: any, course: any) {
      let stateDisciplines = state.disciplines;
      stateDisciplines[course.slug] = course.disciplines;
      state.disciplines = {};
      state.disciplines = stateDisciplines;
    },

    SET_SUBJECTS(state: any, discipline: any) {
      let stateSubjects = state.subjects;
      stateSubjects[discipline.slug] = discipline.subjects;
      state.subjects = {};
      state.subjects = stateSubjects;
    },

    SET_TOPICS(state: any, subject: any) {
      let stateTopics = state.topics;
      stateTopics[subject.slug] = subject.topics;
      state.topics = {};
      state.topics = stateTopics;
    },
    SET_VIDEOS_PEPPER(state: any, lesson: any) {
      state.videosFromPepper = lesson.videos;
    },
  },
  actions: {
    async PULL_CATEGORIES({ commit }: any) {
      let response = await chimeraQuery(`query getChimeraCategoriesDexAdmin{
        chimera {
          categories {
            name
            slug
          }
        }
      }`);
      commit('SET_CATEGORIES', response.data.chimera.categories);
    },

    async PULL_DESCOMPLICA_COURSES({ commit }: any) {
      let response = await chimeraQuery(`query getChimeraCoursesDexAdmin{
        chimera {
          courses {
            name
            slug
            _id
          }
        }
      }`);
      commit('SET_DESCOMPLICA_COURSES', response.data.chimera.courses);
    },

    async PULL_DISCIPLINES({ commit }: any, courseSlug: string) {
      // TODO: treat cases where no course slug
      let response = await chimeraQuery(
        `query getChimeraDisciplinesDexAdmin($courseSlug: String!) {
        chimera {
          course(slug: $courseSlug) {
            name
            slug
            disciplines {
              name
              slug
            }
          }
        }
      }`,
        {
          courseSlug: courseSlug,
        },
      );
      let course = response.data.chimera.course;
      if (course) {
        commit('SET_DISCIPLINES', course);
      }
    },

    async PULL_SUBJECTS({ commit }: any, disciplineSlug: string) {
      // TODO: treat cases where no discipline slug
      if (disciplineSlug) {
        let response = await chimeraQuery(
          `query getChimeraSubjectsDexAdmin($disciplineSlug: String!) {
          chimera {
            discipline(slug: $disciplineSlug) {
              name
              slug
              subjects {
                name
                slug
              }
            }
          }
        }`,
          {
            disciplineSlug: disciplineSlug,
          },
        );
        let discipline = response.data.chimera.discipline;
        if (discipline) {
          commit('SET_SUBJECTS', discipline);
        }
      }
    },

    async PULL_DESCOMPLICA_TOPICS(
      { commit }: any,
      { subjectSlug, disciplineSlug }: any,
    ) {
      // TODO: treat cases where no subject/discipline slug
      if (subjectSlug && disciplineSlug) {
        let response = await chimeraQuery(
          `query getChimeraTopicsDexAdmin($disciplineSlug: String!, $subjectSlug: String! ) {
          chimera {
            discipline(slug: $disciplineSlug) {
              subject(slug: $subjectSlug) {
                name
                slug
                topics {
                  name
                  slug
                }
              }
            }
          }
        }`,
          {
            disciplineSlug: disciplineSlug,
            subjectSlug: subjectSlug,
          },
        );
        let discipline = response.data.chimera.discipline;
        if (discipline && discipline.subject) {
          commit('SET_TOPICS', discipline.subject);
        }
      }
    },
    async PULL_VIDEOS_PEPPER(
      { commit }: any,
      { lessonSlug, disciplineSlug }: any,
    ) {
      if (lessonSlug && disciplineSlug) {
        let response = await chimeraQuery(
          `query getChimeraVideosDexAdmin($disciplineSlug: String!, $lessonSlug: String! ) {
          chimera {
            discipline (slug: $disciplineSlug) {
              lesson( slug: $lessonSlug) {
                videos {
                  name
                  slug
                  description
                  duration
                  kalturaVideoId
                }
              }
            }
          }
        }`,
          {
            disciplineSlug: disciplineSlug,
            lessonSlug: lessonSlug,
          },
        );
        const discipline = response.data.chimera.discipline;
        if (!discipline)
          throw 'A disciplina não foi encontrada! Verifique se está escrito de forma correta ou se não há nenhum espaço antes ou depois do slug';

        const lesson = discipline.lesson;
        if (!(lesson && lesson.videos))
          throw 'A lesson não foi encontrada! Verifique se está escrito de forma correta ou se não há nenhum espaço antes ou depois do slug';

        commit('SET_VIDEOS_PEPPER', lesson);
      }
    },
  },
};
